import EsusView from 'components/esus/EsusView'

export default function ResumoProducaoView() {
  return <EsusView url='/pec/user/relatorios/producao/analiticoResumoProducao' />
}
